import React, { useEffect } from "react";
import { formatCurrency } from "@trussle/external-components";
import { CTA } from "./CTA";
import { useFormContext } from "../context/FormContext";
import { FF2EventName, trackFF2Event } from "../analytics";

export const MortgageTooSmall: React.FC = () => {
  const { recalculateStep, formData } = useFormContext();

  useEffect(() => {
    trackFF2Event(FF2EventName.MORTGAGE_TOO_SMALL, formData);
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    recalculateStep();
  };

  return (
    <form className="heroff2-form" onSubmit={handleSubmit}>
      <h2>Thank you.</h2>
      <h3>
        It looks like you need a mortgage that's less than £
        {formatCurrency(MIN_MORTGAGE_AMOUNT)}
        .
      </h3>
      <p>Unfortunately, we can only help if you are borrowing more than this.</p>
      <br />
      <br />
      <CTA>
        Back
      </CTA>
    </form>
  );
};
